import React from "react";
import "./NoDataContent.scss";
import noDataBanner from "../../../../images/checkAssistant/no-data-banner.jpg";

/**
 * 無資料畫面組件
 *
 * 顯示在選擇的 GA4 資源沒有檢測資料時
 * 包含：
 * - no-data-banner.jpg 圖示
 * - 提示文字
 */
const NoDataContent = () => {
  // 點擊導入 GA4 按鈕，開啟圖靈 GA4 方案頁面
  const handleImportGA4Click = () => {
    window.open(
      "https://www.turingdigital.com.tw/ga4-promotion-plan?_gl=1*17od6xm*_gcl_aw*R0NMLjE3NjE4MjA2MjAuQ2owS0NRandtWXpJQmhDNkFSSXNBSEEzSWtRTkw2X2JiME5uV0xRMFZPS0NnU3F3RUN2a2RHSmVuXzBzSTAxNnBMd3d3bjM3N1pkXzJBc2FBdjR2RUFMd193Y0I.*_gcl_au*Nzc1MzczOTk1LjE3NTgwMDk5MDQ.*_ga*ODY1ODM1OTQwLjE3NTgwMDk5MDQ.*_ga_FSMPL2BRRE*czE3NjIyNDQ0NzUkbzM2JGcxJHQxNzYyMjQ0NjUzJGo1OSRsMCRoMA..*_ga_25W75TTB7P*czE3NjIyNDQ0NzUkbzM2JGcxJHQxNzYyMjQ0NjUyJGo2MCRsMCRoMA",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="no-data-content">
      {/* 上方內容區：圖片和文字（桌機版左右排列） */}
      <div className="no-data-main">
        {/* 無資料圖示 */}
        <div className="no-data-banner">
          <img src={noDataBanner} alt="無資料" />
        </div>

        {/* 提示文字 */}
        <div className="no-data-message">
          <p>
            看起來 <span className="highlight">GA4 尚未完成串接</span>
            ，我們可協助快速檢查並補齊設定。
          </p>
          <p>
            與圖靈聯繫完成導入，讓數據「今天就能用」，並直接連結「即時報表」支援日常決策。
          </p>

          <div className="features">
            <strong>｜事件化追蹤、跨裝置／跨網域整合、彈性漏斗與路徑分析</strong>
          </div>

          <ul className="benefits">
            <li>對齊成效：與各廣告平台一致對讀，避免口徑不一</li>
            <li>即時決策：異常告警與一鍵下鑽，從洞察到行動更快</li>
          </ul>

          <p className="cta-text">
            請點下方按鈕，和圖靈一起導入 GA4，立刻開始優化。
          </p>
        </div>
      </div>

      {/* 導入 GA4 按鈕 */}
      <div className="no-data-button">
        <button className="import-ga4-btn" onClick={handleImportGA4Click}>
          導入GA4
          <div className="arrow-circle">
            <span className="arrow arrow-1"></span>
            <span className="arrow arrow-2"></span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default NoDataContent;
